<template>
  <div>
    <el-dialog
      :title="dialogOption.title"
      :visible.sync="dialogOption.dialogVisible"
      v-el-dialog-drag
      :before-close="close"
      :close-on-click-modal="false"
      append-to-body
      width="800px"
    >
      <el-form ref="form" :model="formData" :rules="rules" label-position="top">
        <el-row :gutter="10">
          <el-col :span="16">
            <el-form-item label="货物名称" prop="goodsName" size="small">
              <el-input v-model="formData.goodsName" type="text" size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="货物代码" prop="goodsNo" size="small">
              <el-input v-model="formData.goodsNo" type="text" size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="货物类型" prop="goodsType" size="small">
              <dict-select
                v-model="formData.goodsType"
                style="width: 100%"
                default
                size="small"
                filterable
                clearable
                :body="{ type: 'goodsType' }"
                :selectedLabel.sync="formData.goodsTypeName"
              >
              </dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="包装类型" prop="packageType" size="small">
              <dict-select
                v-model="formData.packageType"
                style="width: 100%"
                default
                size="small"
                filterable
                clearable
                :body="{ type: 'packageType' }"
                :selectedLabel.sync="formData.packageTypeName"
              >
              </dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="包装件数" prop="goodsQty" size="small">
              <el-input-number
                v-model="formData.goodsQty"
                style="width:100%"
                :min="0"
                :controls="false"
                :precision="0"
                size="small"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="货值" prop="goodsValue" size="small">
              <el-input-number
                v-model="formData.goodsValue"
                style="width:100%"
                :min="0"
                :controls="false"
                :precision="4"
                size="small"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="收入重量kg" prop="goodsWeight" size="small">
              <el-input-number
                v-model="formData.goodsWeight"
                style="width:100%"
                :min="0"
                :controls="false"
                :precision="2"
                size="small"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="收入体积m³" prop="goodsVolume" size="small">
              <el-input-number
                v-model="formData.goodsVolume"
                style="width:100%"
                :min="0"
                :controls="false"
                :precision="2"
                size="small"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="支出重量kg" prop="factWeight" size="small">
              <el-input-number
                v-model="formData.factWeight"
                style="width:100%"
                :min="0"
                :controls="false"
                :precision="2"
                size="small"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="支出体积m³" prop="factVolume" size="small">
              <el-input-number
                v-model="formData.factVolume"
                style="width:100%"
                :min="0"
                :controls="false"
                :precision="2"
                size="small"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="goodsRemarks" size="small">
              <el-input
                v-model="formData.goodsRemarks"
                type="textarea"
                size="small"
                max="200"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close" size="small">
          取消
        </el-button>
        <el-button type="primary" @click="save" size="small">保存 </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    params: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      type: '',
      dialogOption: {
        title: '新增',
        dialogVisible: false,
      },
      formData: {
        orderGoodsCode: '',
        orderCode: '',
        goodsName: '',
        goodsNo: '',
        goodsType: '',
        goodsTypeName: '',
        packageType: '',
        packageTypeName: '',
        goodsQty: 1,
        goodsValue: 0,
        goodsWeight: 0,
        goodsVolume: 0,
        factWeight: 0,
        factVolume: 0,
        goodsRemarks: '',
      },
      rules: {
        goodsName: [
          {
            required: true,
            message: '请输入货物名称',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    load(ref, val) {
      this.reset()
      this.type = ref
      if (ref === 'add') {
        this.dialogOption.title = '新增'
      } else if (ref === 'edit') {
        this.dialogOption.title = '编辑'
        this.formData = val
      }
      this.dialogOption.dialogVisible = true
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let temp = { ...this.formData }
          if (this.type === 'edit') {
            this.$emit('editRowSave', temp)
          } else {
            this.$emit('addRowSave', temp)
          }
          this.close()
        } else {
          return false
        }
      })
    },
    close() {
      this.dialogOption.dialogVisible = false
    },
    reset() {
      this.type = ''
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
      this.formData = {
        orderGoodsCode: '',
        orderCode: '',
        goodsName: '',
        goodsNo: '',
        goodsType: '',
        goodsTypeName: '',
        packageType: '',
        packageTypeName: '',
        goodsQty: 1,
        goodsValue: 0,
        goodsWeight: 0,
        goodsVolume: 0,
        factWeight: 0,
        factVolume: 0,
        goodsRemarks: '',
      }
    },
  },
}
</script>
